import {useNavigate, useParams} from "@tanstack/react-router";
import {type ReactElement, useEffect} from "react";
import {useLoggedOutFee} from "@/components/Providers/LoggedOutFeeProvider.tsx";

const FeeShortLink = (): ReactElement | null => {
    const {code} = useParams({strict: false});
    const {setFeeId} = useLoggedOutFee();
    const navigate = useNavigate();

    useEffect(() => {
        setFeeId(code ?? null);
        void navigate({
            to: "/",
            hash: code ? `feeId=${encodeURIComponent(code)}` : undefined,
            replace: true,
        });
    }, [code]);

    return null;
};

export default FeeShortLink;
